var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHurricane(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224 223.99C206.25 223.99 192 238.24 192 255.99S206.25 287.99 224 287.99S256 273.74 256 255.99S241.75 223.99 224 223.99ZM208 95.994L232.5 21.243C236.25 9.993 226.875 -1.261 215.125 0.114C112 12.368 32 101.619 32 208.002C32 322.877 125.125 416.01 240 416.01L215.5 490.76C211.75 502.011 221.125 513.261 232.875 511.886C336 499.636 416 410.385 416 304.002C416 189.123 322.875 95.994 208 95.994ZM224 351.991C171 351.991 128 308.99 128 255.99S171 159.99 224 159.99S320 202.99 320 255.99S277 351.991 224 351.991Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHurricane);
export default __webpack_public_path__ + "static/media/hurricane.e51c3aad8ab09c227e617ced79e1360d.svg";
export { ForwardRef as ReactComponent };